import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as Plotly from 'plotly.js';
declare global {
  interface Window {
    Plotly: typeof Plotly;
  }
}
@Component({
  selector: 'app-bubble-chart',
  templateUrl: './bubble-chart.component.html',
  styleUrls: ['./bubble-chart.component.css']
})
export class BubbleChartComponent implements OnInit {

  @ViewChild("bubble", { static: true }) private bubble: ElementRef<HTMLElement>;
  @Input() bubbleData: any;
  @Output() bubbleAction = new EventEmitter<any>();
  ngOnInit(): void { }

  ngOnChanges() {
    if (this.bubbleData.length)
      setTimeout(() => {
        this._plotGraph();
      }, 0); 
  }

  private _plotGraph() {
    window.Plotly.newPlot(
      'bubble',
      this.bubbleData, //data provided
      {
        margin: { "l": 0, "r": 0, "b": 0, "t": 0 },
        yaxis: {
          fixedrange: true,
          tickangle: -45,
          range: this.bubbleData[0].yrange,
          showgrid: this.bubbleData[0].showgrid,
          zeroline: this.bubbleData[0].zeroline,
          visible: this.bubbleData[0].visible,
          showticklabels: this.bubbleData[0].showticklabels
        },
        xaxis: {
          fixedrange: true,
          range: this.bubbleData[0].xrange,
          showgrid: this.bubbleData[0].showgrid,
          zeroline: this.bubbleData[0].zeroline,
          visible: this.bubbleData[0].visible,
          showticklabels: this.bubbleData[0].showticklabels
        },
        showlegend: this.bubbleData[0].legend,
        legend: {
          orientation: 'h',
          x: 0.4, y: 1.2
        },
        dragmode: false
      }, {
      displaylogo: false,
      displayModeBar: false,
      responsive: true,
      scrollZoom: true,
      showSendToCloud: true
    });
    (document.getElementById('bubble') as any).on('plotly_click', (data: any) => {
      this.bubbleAction.emit(data);
    });
  }
}

